<template>
  <div class="keyboard" id="map">
    <!-- <h3 style="color:red;font-size:12px">{{markerIcon}}</h3> -->

    <!-- <baidu-map
      class="bm-view"
      :center="center"
      :zoom="zoom"
      @ready="handler"
      @zoomend="zoomChange"
      @moveend="syncCenterAndZoom"
      @touchmove="touchmove"
      @touchend="touchend"
    >
      <bm-geolocation
        ControlAnchor="BMAP_ANCHOR_TOP_RIGHT"
        :autoLocation="true"
      ></bm-geolocation>
      
      <bm-marker
        :position="center"
        animation="BMAP_ANIMATION_BOUNCE"
        :offset="{ width: 16, height: 4 }"
        :icon="{
          url: 'https://tc.datingcloud.cn/static/2.png',
          size: { width: 50, height: 50 },
        }"
      ></bm-marker>
      <bm-marker
        v-for="item of points"
        :key="item.name"
        :position="{ lng: item.lng, lat: item.lat }"
        :icon="IconApi(item, active)"
        @click="infoWindowOpen(item)"
        :title="item.name"
      ></bm-marker>

      <my-overlay
        v-if="shopInfo.name"
        :shopInfo="shopInfo"
        :position="{ lng: active.lng, lat: active.lat }"
      ></my-overlay>
    </baidu-map> -->
    <div id="myMap" class="bm-view"></div>
    <!-- 老版停车场信息浮窗 -->
    <div class="foot_info" v-show="show.footType == 1" v-if="false">
      <div class="info-head">
        <div class="info-name">{{ shopInfo.name }}</div>
        <div class="info-address">
          {{ shopInfo.cdistance }}|{{ shopInfo.address }}
        </div>
      </div>
      <div class="info-body">
        <div class="info-bodyL">
          <div style="color: #1865fe" v-if="shopInfo.ptype == 0">
            剩余车位：{{ shopInfo.remain_park_num
            }}<span style="color: #5b5b5b">
              | 总车位：{{ shopInfo.total_park_num }}</span
            >
          </div>
          <div style="color: #1865fe" v-if="shopInfo.ptype == 2">
            费用：{{ shopInfo.fee }}
          </div>
        </div>
        <div @click="showDriving">
          <img
            src="https://www.urbanservices.cn/Map/static/go.png"
            style="width: 40px; height: 40px"
            alt=""
          />
        </div>
      </div>
      <!-- <div class="positioning">
        <div class="icon" @click="getAddress">
          <img src="https://www.urbanservices.cn/img/position.png" style="height:100%;" alt="">
        </div>
        <div class="text" style="font-size:12px">{{address}}</div>
      </div> -->
    </div>
    <div class="foot_info2" v-show="show.footType == 2" v-if="false">
      <!-- <van-checkbox class="fi2_t" v-model="autoPushMsg"
        >实时推送车场空闲消息</van-checkbox
      > -->
      <div class="fi2_t">龙港智慧停车</div>
      <div class="fi2_card">
        <div class="info-head">
          <div class="info-name">{{ shopInfo.name }}</div>
          <div class="info-address">
            {{ shopInfo.cdistance }}|{{ shopInfo.address }}
          </div>
        </div>
        <div class="info-body">
          <div class="info-bodyL">
            <div
              style="color: #1865fe; padding-top: 10px"
              v-if="shopInfo.ptype == 0"
            >
              剩余车位：{{ shopInfo.remain_park_num
              }}<span style="color: #5b5b5b">
                | 总车位：{{ shopInfo.total_park_num }}</span
              >
            </div>
            <div
              style="color: #1865fe; padding-top: 10px"
              v-if="shopInfo.ptype == 2"
            >
              费用：{{ shopInfo.fee }}
            </div>
            <div style="color: #111111; padding-top: 35px">
              预计用时： 17分钟
            </div>
          </div>
          <div @click="showDriving">
            <img
              src="https://www.urbanservices.cn/Map/static/go.png"
              style="width: 40px; height: 40px"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- show.parkingCar{{show.parkingCar}} -->
    <!-- <div v-if="show.parkingCar" class="parkCarBtn" @click="showSearch">
      我要停车
    </div> -->
    <div class="parkCarBtn" v-show="isInfoWindowOpen" @click="showSearch">
      导航至目的地
    </div>
    <!-- <div v-show="drivingIsShow" class="changeMap">
      <div class="btn" @click="goMap(0)">高德地图</div>
      <div class="btn" @click="goMap(1)">百度地图</div>
      <div class="btn" @click="goMap(2)">取消</div>
    </div> -->
    <div class="bg" v-show="show.isShowSearch && show.searchPage"></div>

    <div class="search_center">
      <div class="sc_top" v-show="!show.searchPage">
        <van-icon name="arrow-left" @click="showmap" />
        <div
          style="flex: 1; display: flex; align-items: center"
          @click="clearSearch"
        >
          {{ searchValue || "搜索目的地 查看附近停车场" }}
        </div>
        <van-icon name="cross" @click="clearSearch" />
      </div>
      <div class="sc_top" v-show="show.searchPage">
        <van-icon name="arrow-left" @click="showmap" />
        <input
          type="text"
          ref="searchinput"
          v-model="searchValue"
          placeholder="搜索目的地 查看附近停车场"
          @input="searchPlace"
        />
        <van-icon name="cross" @click="clearSearch" />
      </div>
      <div class="sc-center" v-if="!searchValue && show.isShowSearch">
        <div
          class="sc_c_item"
          v-for="(item, index) in historyList"
          :key="index"
          @click="changeSearch(item)"
        >
          <van-icon name="clock-o" />{{ item }}
        </div>
        <div
          class="sc_c_clear"
          v-if="historyList.length"
          @click="historyList = []"
        >
          清空搜索历史
        </div>
      </div>
      <div class="sc-center" v-if="searchValue && show.isShowSearch">
        <div
          class="sc_c_item"
          v-for="(item, index) in searchList"
          :key="index"
          @click="showList(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <van-popup
      v-model="show.searchParkList"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="dialog1" v-show="show.searchParkList">
        <div class="d_title">附近停车场</div>
        <div class="d_container">
          <div class="d_c_info" v-for="(item, index) in points" :key="index">
            <div class="info-head">
              <div class="info-name">{{ item.name }}</div>
              <div class="info-address">
                {{ item.cdistance }}|{{ item.address }}
              </div>
            </div>
            <div class="info-body">
              <div class="info-bodyL">
                <div style="color: #1865fe" v-if="item.ptype == 0">
                  剩余车位：{{ item.remain_park_num
                  }}<span style="color: #5b5b5b">
                    | 总车位：{{ item.total_park_num }}</span
                  >
                </div>
                <div style="color: #1865fe" v-if="item.ptype == 2">
                  费用：{{ item.fee }}
                </div>
              </div>
              <div @click="getWay(item)">
                <img
                  src="https://www.urbanservices.cn/Map/static/go.png"
                  style="width: 40px; height: 40px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var T = window.T;
import MyOverlay from "./MyOverlay.vue";
import bus from "@/utils/bus";
import { getCarParkByPosition, getSign, queryPosition } from "../api/index";
export default {
  name: "ParkingMap",
  props: ["addressList"],
  data() {
    return {
      a: 0,
      autoPushMsg: true,
      addre: { start: {}, end: {} },
      searchList: [],
      suggests: [],
      searchValue: "",
      show: {
        footType: 1,
        parkingCar: false,
        searchPage: false,
        isShowSearch: false,
        searchParkList: false
      },
      active: {
        lng: "",
        lat: ""
      },
      shopIcon1: {
        url: "../static/p1-1.png",
        size: {
          width: 54,
          height: 57
        },
        opts: {}
      },
      shopIcon2: {
        url: "../static/p2-1.png",
        size: {
          width: 81,
          height: 87
        },
        opts: {}
      },
      elIcon1: {
        url: "../static/el-1.png",
        size: {
          width: 54,
          height: 57
        },
        opts: {}
      },
      elIcon2: {
        url: "../static/el-2.png",
        size: {
          width: 70,
          height: 76
        },
        opts: {}
      },
      JKIcon2: {
        url: "../static/JK.png",
        size: {
          width: 54,
          height: 57
        },
        opts: {}
      },
      historyList: [],
      drivingIsShow: false,
      showInfo: false,
      shopInfo: {
        name: "",
        address: "",
        lng: "",
        lat: ""
      },
      // URL: "https://longgang.uchoice.cc/ytapi/v1/record/",
      // URL: "http://192.168.3.169:8098/v1/record/",

      URL: "https://tc.datingcloud.cn/v1/record/",
      // URL: "http://192.168.2.114:9019/",

      userIcon: "https://tc.datingcloud.cn/static/address.png",
      form: {
        carCode: "",
        openId: "",
        parkid: "",
        distance: "",
        duration: "",
        remainParkNum1: "",
        address: "我要去哪里"
      },
      parkingMapList: "",
      center: { lng: "", lat: "" },
      center1: { lng: "", lat: "" },
      zoom: 3,
      points: [{ lng: "", lat: "", name: "" }],
      lock: "false",
      address: "",
      BMap: "",
      map: null,
      isCheck: false,
      isTouch: false,
      infoWindow: null, // 信息窗口对象
      currentParkingInfo: null, // 当前点击的停车场信息
      isInfoWindowOpen: false, // 信息窗口是否打开
      longitude: 120.547249,
      latitude: 27.572337,
      localsearch: null
    };
  },
  components: { MyOverlay },
  mounted() {
    // 检查天地图API是否加载
    if (window.T) {
      this.getlocation();
    } else {
      // 等待天地图API加载完成
      let checkTMap = setInterval(() => {
        if (window.T) {
          clearInterval(checkTMap);
          this.getlocation();
        }
      }, 100);

      // 设置超时时间
      setTimeout(() => {
        clearInterval(checkTMap);
        if (!window.T) {
          console.error("天地图API加载失败");
          // 在本地开发环境中给出提示
          if (
            location.hostname === "localhost" ||
            location.hostname === "127.0.0.1"
          ) {
            alert(
              "天地图API加载失败，请检查：\n1. 是否已配置域名白名单\n2. 是否使用HTTPS协议\n3. API密钥是否正确"
            );
          }
        }
      }, 5000);
    }

    // this.getLocation1();
    let that = this;
    // this.getOpenId();
    if (
      sessionStorage.getItem("history") &&
      sessionStorage.getItem("history").length
    ) {
      this.historyList = sessionStorage.getItem("history");
    }

    // this.addressDetail();
  },
  methods: {
    initMap() {},
    getlocation() {
      let that = this;
      var options = {
        enableHighAccuracy: true,
        maximumAge: 1000
      };
      console.log(navigator.geolocation, 454);

      if (navigator.geolocation) {
        console.log(1);

        navigator.geolocation.getCurrentPosition(function(position) {
          console.log(4);
          // 返回用户位置
          // 浏览器支持geolocation
          // 确保天地图API已加载
          that.longitude = position.coords.longitude;
          that.latitude = position.coords.latitude;
          if (window.T) {
            console.log(2);
            that.map = new T.Map("myMap");
            that.map.centerAndZoom(
              new T.LngLat(that.longitude, that.latitude),
              18
            );
            that.center = { lng: that.longitude, lat: that.latitude };
            that.center1 = { lng: that.longitude, lat: that.latitude };
            // 添加用户位置标记
            let myIcon = new T.Icon({
              iconUrl: that.userIcon,
              iconSize: new T.Point(36, 36)
            });
            let marker = new T.Marker(
              new T.LngLat(that.longitude, that.latitude),
              {
                icon: myIcon
              }
            );
            that.map.addOverLay(marker);
            let config = {
              pageCapacity: 10, //每页显示的数量
              onSearchComplete: that.localSearchResult //接收数据的回调函数
            };
            //创建搜索对象
            that.localsearch = new T.LocalSearch(that.map, config);
            that.addPoints();
          }
        });
      }
    },
    //拖拽地图
    touchmove() {
      this.map && this.map.enableDragging();
    },
    //拖拽结束
    touchend() {
      let that = this;
      that.isTouch = true;
      setTimeout(() => {
        that.addPoints();
      }, 300);
      this.map && this.map.disableDragging();
    },
    getOpenId() {
      let that = this;
      this.access_code = this.getUrlParam("code");
      this.local = window.location.href;
      this.local = encodeURIComponent(this.local);
      if (
        this.access_code == null ||
        this.access_code == "" ||
        this.access_code == "undefined"
      ) {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx602a4d7f2f5df4a5&redirect_uri=" +
          that.local +
          "&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect";
      } else {
        this.$axios
          .post(
            `https://lwzfj.chekuapp.com:89/CarCoolWebService/Park/Api.ashx?op=WXGetOpenId&code=${
              this.access_code
            }`
          )
          .then(function(response) {
            if (response.data.errcode == 0) {
              that.form.openid = response.data.data.openid;
              that.getGeolocation();
            } else {
              location.href = "https://www.urbanservices.cn/Map/";
              // alert(response.errmsg);
            }
          });
      }
    },
    showmap() {
      this.show.searchPage = false;
      this.show.isShowSearch = false;
      // isShowSearch
      // this.searchList=[];
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
    },
    showList(obj) {
      console.log(111);
      console.log(obj);
      // this.center = {
      //   lat: obj.location.lat,
      //   lng: obj.location.lng,
      // };
      let lng = obj.lonlat.split(",")[0];
      let lat = obj.lonlat.split(",")[1];
      this.center.lat = lat;
      this.center.lng = lng;
      this.map.centerAndZoom(new T.LngLat(lng, lat), 18);
      this.addPoints();
      // this.historyList.push(obj.name);
      this.changeSearch(obj.name);
      this.show.isShowSearch = false;
      this.show.parkingCar = false;
      this.showInfo = false;
      this.showmap();
      // console.log(this.center);

      // this.show.searchParkList = true;
    },
    localSearchResult(result) {
      this.localsearch.search(this.searchValue, 4);
    },
    changeSearch(val) {
      if (this.historyList.indexOf(val) == -1) {
        this.historyList.push(val);
        sessionStorage.setItem("historyList", this.historyList);
      }
      this.searchValue = val;
      this.searchPlace();
    },
    searchPlace() {
      this.localsearch.search(this.searchValue);
      this.searchList = [];
      if (
        this.localsearch.result &&
        this.localsearch.result.suggests &&
        this.localsearch.result.suggests.length > 0
      ) {
        this.localsearch.result.suggests.map(u => {
          this.searchList.push(u);
        });
        console.log(this.searchList, 54654);
      }
    },
    onSearch() {
      alert("onSearch");
    },
    onCancel() {
      alert("onCancel");
      this.show.searchPage = false;
    },
    // 初始化地图
    handler({ BMap, map }) {
      this.zoom = 16;
      this.BMap = BMap;
      this.map = map;
      // 获取定位
      this.getAddress();

      // 初始化停车场
      // this.elPoints();
    },
    // 获取定位
    getAddress() {},
    // 初始化停车场
    addPoints(isFirst = false) {
      if (this.isTouch) {
        this.isTouch = false;
        this.isCheck = true;
      }

      // 确保地图对象存在
      if (!this.map) {
        console.error("地图对象未初始化");
        return;
      }

      let p = this.map.getCenter();
      let G = this.bd09ToTMap(p.lng, p.lat);
      let data = {
        lat: this.isCheck ? G.lat : this.center.lat,
        lon: this.isCheck ? G.lng : this.center.lng,
        userLat: this.center1.lat || G.lat,
        userLon: this.center1.lng || G.lng
      };

      this.lock = true;
      getCarParkByPosition(data)
        .then(res => {
          if (res.code != 200) {
            console.error("获取停车场数据失败:", res.errmsg);
            this.lock = false;
            return;
          }

          this.parkingMapList = res.data;
          this.timeRefusr = new Date().getTime();

          // 清除之前添加的覆盖物，但保留用户位置标记
          if (this.map) {
            let overlays = this.map.getOverlays();
            for (let i = 0; i < overlays.length; i++) {
              // 不清除用户位置标记
              if (
                !(overlays[i] instanceof T.Marker) ||
                (overlays[i].getLngLat().lng !== this.center.lng &&
                  overlays[i].getLngLat().lat !== this.center.lat)
              ) {
                this.map.removeOverLay(overlays[i]);
              }
            }
          }

          // 添加新的停车场标记
          if (this.parkingMapList && this.parkingMapList.length > 0) {
            this.parkingMapList.forEach((item, index) => {
              const position = {
                id: item.id,
                name: item.name,
                address: item.street ? item.street : item.address,
                lng: item.longitude,
                lat: item.latitude,
                statusName: item.statusName,
                ptype: item.isCharge ? "2" : "0",
                parkingStatus: item.parkingStatus,
                remain_park_num: item.remaining,
                total_park_num: item.total,
                cdistance: item.juli / 1000 + "km",
                wc: item.restroom,
                fastTotal: item.fastTotal || 0,
                fastCharge: item.fastCharge || 0,
                trickleTotal: item.trickleTotal || 0,
                trickleCharge: item.trickleCharge || 0,
                chargeFee: item.chargeFee || ""
              };

              // 创建标记
              if (this.map) {
                let lonlat = this.bd09ToTMap(position.lng, position.lat);
                let marker = new T.Marker(new T.LngLat(lonlat.lng, lonlat.lat));

                // 添加点击事件监听器
                marker.addEventListener("click", () => {
                  this.showInfoWindow(position);
                });

                // 添加标记到地图
                this.map.addOverLay(marker);
              }
            });
          }

          this.lock = false;
        })
        .catch(error => {
          console.error("请求停车场数据时发生错误:", error);
          this.lock = false;
        });
    },

    // 显示信息窗口
    showInfoWindow(parkingInfo) {
      this.shopInfo = parkingInfo;
      // 创建信息窗口内容
      let infoContent = `
        <div style="padding: 10px; min-width: 200px;">
          <h3 style="margin: 0 0 10px 0; font-size: 16px;">${
            parkingInfo.name
          }</h3>
          <p style="margin: 5px 0; font-size: 12px; color: #666;">距离: ${
            parkingInfo.cdistance
          }</p>
      `;

      // 添加车位信息
      if (parkingInfo.ptype == "0") {
        infoContent += `
          <p style="margin: 5px 0; font-size: 12px; color: #1865fe;">
            剩余车位: ${parkingInfo.remain_park_num}
            <span style="color: #5b5b5b;">| 总车位: ${
              parkingInfo.total_park_num
            }</span>
          </p>
        `;
      }

      // 添加充电信息
      if (parkingInfo.ptype == "2") {
        infoContent += `
          <p style="margin: 5px 0; font-size: 12px; color: #1bc27d;">
            快充: ${parkingInfo.fastCharge}/${parkingInfo.fastTotal}
            <span style="color: #5b5b5b;">| 慢充: ${
              parkingInfo.trickleCharge
            }/${parkingInfo.trickleTotal}</span>
          </p>
        `;
      }

      // 添加车位状态信息
      if (
        parkingInfo.parkingStatus !== undefined &&
        parkingInfo.parkingStatus !== ""
      ) {
        const statusColors = ["#23BE87", "#1966ff", "#FE464C"];
        const statusColor = statusColors[parkingInfo.parkingStatus] || "#666";
        infoContent += `
          <p style="margin: 5px 0; font-size: 12px; color: ${statusColor};">
            车位状态: ${parkingInfo.statusName}
          </p>
        `;
      } else {
        infoContent += `
          <p style="margin: 5px 0; font-size: 12px; color: #666;">
            该停车场暂无车位信息
          </p>
        `;
      }

      // 添加公共厕所信息
      const wcText = parkingInfo.wc == 1 ? "有" : "无";
      const wcColor = parkingInfo.wc == 1 ? "#23BE87" : "#FE464C";
      infoContent += `
        <p style="margin: 5px 0; font-size: 12px; color: ${wcColor};">
          公共厕所: ${wcText}
        </p>
      `;

      // 添加充电电价信息（如果有充电设施）
      if (
        (parkingInfo.fastTotal > 0 || parkingInfo.trickleTotal > 0) &&
        parkingInfo.chargeFee
      ) {
        infoContent += `
          <p style="margin: 5px 0; font-size: 12px; color: #3889ff;">
            充电电价: ${parkingInfo.chargeFee}
          </p>
        `;
      }

      infoContent += `
        </div>
      `;

      // 设置信息窗口位置
      let lonlat = this.bd09ToTMap(parkingInfo.lng, parkingInfo.lat);
      let position = new T.LngLat(lonlat.lng, lonlat.lat);

      // 创建信息窗口对象并打开
      if (!this.infoWindow) {
        this.infoWindow = new T.InfoWindow(infoContent, {
          offset: new T.Point(0, -30)
        });
        // 监听信息窗口关闭事件
        this.infoWindow.addEventListener("close", () => {
          this.isInfoWindowOpen = false;
        });
      } else {
        this.infoWindow.setContent(infoContent);
      }

      // 打开信息窗口
      this.map.openInfoWindow(this.infoWindow, position);
      // 设置信息窗口打开状态
      this.isInfoWindowOpen = true;

      // 使用 setTimeout 确保 DOM 已更新后再添加事件监听器
      setTimeout(() => {
        const navigateBtn = document.getElementById("navigateBtn");
        if (navigateBtn) {
          navigateBtn.addEventListener("click", () => {
            this.navigateToParking(parkingInfo);
          });
        }
      }, 100);

      // 保存当前点击的停车场信息
      this.currentParkingInfo = parkingInfo;
    },

    // 导航至停车场
    navigateToParking(parkingInfo) {
      // 将天地图坐标转换为GCJ-02坐标（用于微信导航）
      let gcjCoord = this.tmapToGCJ02(parkingInfo.lng, parkingInfo.lat);

      // 调用微信JS-SDK进行导航
      this.$axios
        .get(this.URL + "getSign")
        .then(response => {
          if (response.data.code == 200) {
            wx.config({
              debug: false,
              appId: "wx84684301e1d62116",
              timestamp: "" + response.data.data.timeStamp,
              nonceStr: response.data.data.nonceStr,
              signature: response.data.data.signature,
              jsApiList: ["checkJsApi", "openLocation"]
            });

            wx.ready(() => {
              wx.openLocation({
                latitude: gcjCoord.lat,
                longitude: gcjCoord.lng,
                name: parkingInfo.name,
                address: parkingInfo.address,
                scale: 15,
                success(res) {
                  console.log("导航成功", res);
                },
                fail(error) {
                  console.log("导航失败", error);
                  alert("导航功能调用失败：" + JSON.stringify(error));
                }
              });
            });

            wx.error(res => {
              console.log("wx.config配置失败", res);
              alert("微信配置失败：" + JSON.stringify(res));
            });
          } else {
            alert("获取签名失败：" + response.errmsg);
          }
        })
        .catch(error => {
          console.log("获取签名异常", error);
          alert("获取签名异常：" + JSON.stringify(error));
        });
    },
    IconApi(item, active) {
      let that = this;
      if (item.ptype == 0) {
        if (item.lng == active.lng && item.lat == active.lat) {
          return that.shopIcon2;
        } else {
          return that.shopIcon1;
        }
      }
      if (item.ptype == 1) {
        return that.JKIcon2;
      }
      if (item.ptype == 2) {
        if (item.lng == active.lng && item.lat == active.lat) {
          return that.shopIcon2;
        } else {
          return that.elIcon2;
        }
      }
    },
    // 显示搜索页
    showSearch() {
      let that = this;
      console.log(this.shopInfo);

      // 注意：wx.openLocation需要使用腾讯/高德坐标系，而不是天地图坐标系
      // 所以我们需要将天地图坐标转换为GCJ-02坐标（中国火星坐标系）
      let gcjCoords = this.bd09_To_Gcj02(this.shopInfo.lat, this.shopInfo.lng);
      let parkName = this.shopInfo.name;
      let lon = parseFloat(gcjCoords.lng);
      let lat = parseFloat(gcjCoords.lat);
      console.log("最终用于导航的坐标:", lon, lat);

      // 显示loading
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0 // 持续显示
      });

      // let locUrl= location.href.split("#")[0];
      // let data ={
      //   "url":"tc.datingcloud.cn"
      // }
      // console.log(data);
      getSign()
        .then(function(response) {
          // 关闭loading
          that.$toast.clear();

          if (response.code == 200) {
            console.log(response, 2222);
            wx.config({
              // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              debug: false,
              // 必填，公众号的唯一标识
              appId: "wx84684301e1d62116",
              // 必填，生成签名的时间戳
              timestamp: "" + response.data.timeStamp,
              // 必填，生成签名的随机串
              nonceStr: response.data.nonceStr,
              // 必填，签名，见附录1
              signature: response.data.signature,
              // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              jsApiList: ["checkJsApi", "openLocation"]
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ["openLocation"],
                success: function(res) {
                  console.log(444);
                  console.log("res", res, typeof lat, typeof lon);
                  wx.openLocation({
                    latitude: lat, // 纬度，浮点数，范围为90 ~ -90
                    longitude: lon, // 经度，浮点数，范围为180 ~ -180。
                    name: parkName, // 位置名
                    address: that.shopInfo.address || "", // 地址详情说明
                    scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
                    success(res) {
                      console.log("导航成功", res);
                    },
                    fail(error) {
                      console.log("导航失败", error);
                      alert("导航功能调用失败：" + JSON.stringify(error));
                    }
                  });
                },
                fail(error) {
                  console.log("checkJsApi失败", error);
                  alert("检查JS接口失败：" + JSON.stringify(error));
                }
              });
            });
            wx.error(function(res) {
              console.log("wx.config配置失败", res);
              alert("微信配置失败：" + JSON.stringify(res));
            });
          } else {
            alert(response.msg);
          }
        })
        .catch(function(error) {
          // 关闭loading
          that.$toast.clear();
          console.error("getSign请求失败", error);
          alert("请求失败，请稍后重试");
        });
    },
    //百度坐标系 (BD-09) to 火星坐标系 (GCJ-02)
    bd09_To_Gcj02(lat, lng) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return { lat: lats, lng: lngs };
    },
    //高德坐标转百度（传入经度、纬度）
    gps_bgps(gg_lng, gg_lat) {
      var X_PI = (Math.PI * 3000.0) / 180.0;
      var x = gg_lng,
        y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lng = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return {
        bd_lat: bd_lat,
        bd_lng: bd_lng
      };
    },
    // 拖动地图时隐藏门店信息
    syncCenterAndZoom(e) {
      // this.shopInfo= {
      //   name: "",
      //   address: "",
      //   lng: "",
      //   lat: "",
      // };
      // this.center = { lng: e.target.re.lng, lat: e.target.re.lat };
      // this.showInfo = false;
      // this.getAddress();
      // this.addPoints();
    },
    // 天地图坐标系(WGS-84)转GCJ-02坐标系（中国火星坐标系）
    tmapToGCJ02(lng, lat) {
      // 更精确的转换参数
      const PI = 3.1415926535897932384626;
      const A = 6378245.0;
      const EE = 0.00669342162296594323;

      // 确保lng和lat是数值类型
      lng = parseFloat(lng);
      lat = parseFloat(lat);

      console.log("转换前坐标:", lng, lat);

      // 判断是否在中国范围内，不在范围内不转换
      if (this.outOfChina(lat, lng)) {
        console.log("坐标不在中国范围内，不进行转换");
        return { lng, lat };
      }

      let dLat = this.transformLat(lng - 105.0, lat - 35.0);
      let dLon = this.transformLon(lng - 105.0, lat - 35.0);
      const radLat = (lat / 180.0) * PI;
      let magic = Math.sin(radLat);
      magic = 1 - EE * magic * magic;
      const sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / (((A * (1 - EE)) / (magic * sqrtMagic)) * PI);
      dLon = (dLon * 180.0) / ((A / sqrtMagic) * Math.cos(radLat) * PI);
      const mgLat = lat + dLat;
      const mgLon = lng + dLon;

      console.log("转换偏移量:", dLon, dLat);
      console.log("转换后坐标:", mgLon, mgLat);

      return { lng: mgLon, lat: mgLat };
    },

    // 判断是否在中国范围外
    outOfChina(lat, lng) {
      // 判断是否在中国范围
      if (lng < 72.004 || lng > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    },
    // 百度坐标系 (BD-09) 转 天地图坐标系
    bd09ToTMap(lng, lat) {
      // 百度坐标系转火星坐标系 (GCJ-02)
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let gcj_lng = z * Math.cos(theta);
      let gcj_lat = z * Math.sin(theta);

      // 火星坐标系 (GCJ-02) 转天地图坐标系（WGS-84）
      // 天地图使用的是WGS-84坐标系，与GCJ-02坐标系之间存在一定的偏差
      // 这里使用近似转换，实际应用中可能需要更精确的转换算法
      const a = 6378245.0;
      const ee = 0.00669342162296594323;

      let dLat = this.transformLat(gcj_lng - 105.0, gcj_lat - 35.0);
      let dLon = this.transformLon(gcj_lng - 105.0, gcj_lat - 35.0);

      const radLat = (gcj_lat / 180.0) * Math.PI;
      let magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      const sqrtMagic = Math.sqrt(magic);

      dLat =
        (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * Math.PI);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * Math.PI);

      const wgs_lng = gcj_lng - dLon;
      const wgs_lat = gcj_lat - dLat;

      return {
        lng: wgs_lng,
        lat: wgs_lat
      };
    },
    // 辅助函数：转换纬度
    transformLat(x, y) {
      let ret =
        -100.0 +
        2.0 * x +
        3.0 * y +
        0.2 * y * y +
        0.1 * x * y +
        0.2 * Math.sqrt(Math.abs(x));
      ret +=
        ((20.0 * Math.sin(6.0 * x * Math.PI) +
          20.0 * Math.sin(2.0 * x * Math.PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin((y / 3.0) * Math.PI)) *
          2.0) /
        3.0;
      ret +=
        ((160.0 * Math.sin((y / 12.0) * Math.PI) +
          320 * Math.sin((y * Math.PI) / 30.0)) *
          2.0) /
        3.0;
      return ret;
    },
    // 辅助函数：转换经度
    transformLon(x, y) {
      let ret =
        300.0 +
        x +
        2.0 * y +
        0.1 * x * x +
        0.1 * x * y +
        0.1 * Math.sqrt(Math.abs(x));
      ret +=
        ((20.0 * Math.sin(6.0 * x * Math.PI) +
          20.0 * Math.sin(2.0 * x * Math.PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin((x / 3.0) * Math.PI)) *
          2.0) /
        3.0;
      ret +=
        ((150.0 * Math.sin((x / 12.0) * Math.PI) +
          300.0 * Math.sin((x / 30.0) * Math.PI)) *
          2.0) /
        3.0;
      return ret;
    },
    // 点击导航显示地图选择
    showDriving() {
      let _this = this;
      // _this.showInfo = false;
      _this.drivingIsShow = true;
      // http://api.map.baidu.com/marker?location=_this.shopInfo.lat,_this.shopInfo.lng&title=&content=&output=html"
    },
    // 选择高德地图或者百度地图并跳转
    goMap(mapStatu) {
      let _this = this;
      _this.drivingIsShow = false;
      let lng = _this.shopInfo.lng;
      let lat = _this.shopInfo.lat;
      if (mapStatu == 0 || mapStatu == 1) {
        if (mapStatu == 0) {
          let obj = _this.gps_bgps(
            _this.shopInfo.longitude,
            _this.shopInfo.latitude
          );
          lng = obj.bd_lng;
          lat = obj.bd_lat;
          // return
          // _this.goAmapAPP(lng,lat,_this.shopInfo.name)
          window.location.href =
            "https://uri.amap.com/marker?position=" +
            lng +
            "," +
            lat +
            "&name=" +
            _this.shopInfo.name;
        } else if (mapStatu == 1) {
          window.location.href =
            "http://api.map.baidu.com/marker?location=" +
            _this.shopInfo.lat +
            "," +
            _this.shopInfo.lng +
            "&title=" +
            _this.shopInfo.name +
            "&content=&output=html";
        }
      }
      // return;
    },
    zoomChange(e) {
      this.zoom = e.target.getZoom();
    },
    // 将百度地图经纬度转换为腾讯/高德地图经纬度
    bMapTransQQMap(lng, lat) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats
      };
    },
    clearSearch() {
      this.searchValue = "";
      this.show.searchPage = true;
      this.show.isShowSearch = true;
      //input框聚焦
      this.$nextTick(() => {
        this.$refs.searchinput.focus();
      });
    },

    goAmapAPP(lng, lat, name) {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var url = ``;
      if (isAndroid) {
        url =
          "androidamap://navi?sourceApplication=amap&poiname=" +
          name +
          "&lat=" +
          lat +
          "&lon=" +
          lng +
          "&dev=1&style=2";
        window.open(url, "_blank");
      } else if (isiOS) {
        location.href =
          "iosamap://navi?sourceApplication=amap&poiname=" +
          name +
          "&lat=" +
          lat +
          "&lon=" +
          lng +
          "&dev=1&style=2";
      }
    },
    getWay(shopinfo) {
      this.infoWindowOpen(shopinfo);
      // this.showDriving();
      this.shopInfo = shopinfo;
      this.show.searchParkList = false;
      this.showmap();
      this.center = { lng: shopinfo.lng, lat: shopinfo.lat };
      this.addre = {
        start: { lng: this.center1.lng, lat: this.center1.lat },
        end: { lng: shopinfo.lng, lat: shopinfo.lat }
      };
      this.show.footType = 2;
    }
  }
};
</script>
<style>
.keyboard .bg {
  width: 100%;
  height: 100%;
  background-color: #f7f7f9;
  position: absolute;
  top: 0;
  left: 0;
}

.keyboard .z2 {
  z-index: 2;
}

.keyboard .bm-view {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 12px;
}

.keyboard .foot_info {
  width: 90vw;
  position: fixed;
  bottom: 77px;
  left: 5vw;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 17.5px;
  box-sizing: border-box;
  box-shadow: 0 0 4px 1px #dddddd;
  transition: transform 0.5s ease-in-out;
}

.keyboard .foot_info2 {
  width: 100vw;
  position: fixed;
  bottom: 0;
  background: linear-gradient(0deg, #f2f3f5, #e4ebfd);
  padding: 0 15px 48px;
  box-sizing: border-box;
  border-radius: 12px 12px 0 0;
}

.keyboard .fi2_t {
  height: 40px;
  line-height: 40px;
  width: 100%;
  padding: 0 5px;
  box-sizing: border-box;
  /* display: flex;
  align-content: center; */
}

.keyboard .fi2_t .van-checkbox__icon .van-icon {
  width: 18px;
  height: 18px;
  border: none;
  background-color: #7486ec;
}

.keyboard .fi2_t .van-checkbox__icon--round .van-icon {
  /* 复选框默认状态 */
  border-radius: 4px !important;
}

.keyboard .fi2_t .van-checkbox__icon--checked .van-icon {
  /* 复选框选中状态 */
}

.fi2_card {
  width: 100%;
  border-radius: 12px;
  padding: 15px;
  box-sizing: border-box;
  background-color: #fff;
}

.keyboard .info-head {
  max-width: 90%;
  text-align: left;
}

.keyboard .info-name {
  font-size: 18px;
  color: #2f2f2f;
  padding-bottom: 10px;
}

.keyboard .info-address {
  width: 100%;
  font-size: 12px;
  color: #868686;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.keyboard .info-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.keyboard .info-bodyL {
  text-align: left;
}

.keyboard .info-bodyR {
  font-size: 10px;
  color: #fff;
  /* 待注释 */

  background-color: #1864ff;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 3px 0px #1864ff;
  transform: translate(0, 20%);
}

.keyboard .positioning {
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  color: #5b6f9f;
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  background-color: #e9effd;
  border-radius: 12px;
  transform: translate(-10px, -120%);
  text-align: left;
  display: flex;
  align-items: center;
}

.keyboard .positioning .icon {
  font-size: 10px;
  line-height: 36px;
  /* 待注释 */

  display: inline-flex;
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 6px;
  box-sizing: border-box;
  box-shadow: 0 0 4px 1px #dddddd;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
}

.keyboard .positioning .text {
  display: inline-block;
  width: calc(100% - 46px);
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.keyboard .changeMap {
  position: fixed;
  width: 40vw;
  background-color: #fff;
  left: 50vw;
  transform: translateX(-50%);
  bottom: 10vh;
  z-index: 1000;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 3px 0 #7e8c8d;
}

.keyboard .changeMap .btn {
  display: block;
  padding: 10px 0;
  width: 100%;
  color: #7e8c8d;
  border-bottom: 1px solid #7e8c8d;
}

.keyboard .changeMap .btn:last-child {
  border-bottom: none;
}

.keyboard .parkCarBtn {
  width: 90vw;
  height: 40px;
  line-height: 40px;
  background-color: #1966ff;
  position: fixed;
  bottom: 24px;
  left: 5vw;
  border-radius: 20px;
}

.keyboard .search_center {
  position: relative;
  z-index: 2;
  font-size: 12px;
  color: #000;
  width: 100%;
  /* background-color: #fff; */
  padding: 23px 15px;
  box-sizing: border-box;
}

.keyboard .sc_top {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  font-size: 15px;
  display: flex;
  align-content: center;
  border: 1px solid #e8e8e8;
  color: #333333;
  margin-bottom: 10px;
}

.keyboard .sc_top .van-icon-arrow-left,
.keyboard .sc_top .van-icon-cross {
  padding: 13px 13px;
}

.keyboard .sc_top input {
  flex: 1;
}

.keyboard .sc-center {
  font-size: 14px;
}

.keyboard .sc_c_item {
  display: flex;
  align-items: center;
  padding-left: 5px;
  height: 45px;
  line-height: 45px;
  color: #6e6e6e;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 90%;
}

.keyboard .sc_c_item .van-icon-clock-o {
  margin-right: 10px;
  color: #cbcbcb;
  font-size: 19px;
}

.keyboard .sc_c_clear {
  color: #6e6e6e;
}

.keyboard .van-popup {
  overflow-y: unset;
  border-radius: 12px 12px 0 0;
  background-color: #f6f6f8;
}

.keyboard .dialog1 {
  width: 100%;
  height: 100%;
  position: relative;
  /* position: absolute;
  bottom: 0;
  left: 0; */
  background-color: #ffffff;
  border-radius: 12px 12px 0 0;
  padding: 22px 15px 0;
  box-sizing: border-box;
}

.keyboard .dialog1::before {
  content: "•选择停车场后，点击导航可以导航至停车场";
  display: block;
  color: #666666;
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 50%;
  width: calc(100% - 24px);
  border: 1px solid #ffc4b0;
  background-color: #fcede6;
  text-align: left;
  padding: 12px 14px;
  box-sizing: border-box;
  border-radius: 8px;
  transform: translate(-50%, -50%);
}

.keyboard .d_title {
  color: #de6a41;
  background-color: #fdf3f1;
  border: 1px solid #d97a5c;
  border-radius: 14px;
  height: 28px;
  line-height: 28px;
  margin: 10px 0;
}

.keyboard .d_container {
  width: 100%;
  height: calc(100% - 28px);
  overflow-y: scroll;
}

.keyboard .d_c_info {
  width: 98%;
  margin: 10px auto 0;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 10px 17.5px;
  box-sizing: border-box;
  box-shadow: 0 0 4px 0 #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/ParkingMap.vue